
export const TaskHeadings1=[
    {
        name:'Booking No',
        value:'megaCabsBookingNo'
    },
    {
        name:'Booking Time',
        value:'bookingTime'
    },
    {
        name:'Booking Via',
        value:'bookingViaType'
    },
    // {
    //     name:'Booking By',
    //     value:'createdByUserType'
    // },
    {
        name:'Intergrator',
        value:'integratorName'
    },
    {
        name:'Preferred cab',
        value:'carType'
    },
    {
        name:'Package',
        value:'packageName'
    },
    {
        name:'Zone',
        value:'pickUpZoneName'
    },
]

export const TaskHeadings2=[
    {
        name:'Pickup Date',
        value:'pickUpDateTime'
    },
    {
        name:'Start time',
        value:'tripStartTime'
    },
    {
        name:'End time',
        value:'tripEndTime'
    },
    {
        name:'Distance',
        value:'tripDistance'
    },
    {
        name:'Fare',
        value:'tripFare'
    },
    {
        name:'Payment Type',
        value:'paymentModeType'
    },
]



export const TaskData1={
    booking_number:'BNC922030082',
    booking_time:'Sep 24,2022 1:30 PM',
    booking_via:'Customer App',
    booking_by:'Shylaja',
    intergrator:'MegaCabs',
    preferred_cab:'MUV',
    package:'NO',
}

export const TaskData2={
    zone:'Adhcnk',
    pickup_date:'Sep 28, 2022 12:50 PM',
    start_time:'Sep 28, 2022 12:50:46 PM',
    end_time:'Sep 28, 2022 1:39:46 PM',
    distance:'17 km',
    fare:'INR 239'
}